import { IonAlert } from '@ionic/react';
import { addDays, dateDiffHours, getNow, RELEASE_VERSION } from 'model';
import { useGetReleaseVersionQuery } from '../api/VersionApi';
import styles from './ReleaseVersionRefresh.module.css';
import { usePreferences } from '../hooks/usePreferences.js';
import { useDevice } from '../hooks/useDevice.js';
/**
 * Shows a popup when a new release is available, ensures that this popup is not shown more than once every
 * 2 hours
 * @returns {JSX.Element} The release version refresh popup
 */
export function ReleaseVersionPopup(): JSX.Element {
	const device = useDevice();
	const [lastRefreshDate, setLastRefreshDate] = usePreferences('lastRefreshDate');
	const timeSinceLastRefresh = !lastRefreshDate ? 0 : dateDiffHours(lastRefreshDate, getNow());
	const { data, isError } = useGetReleaseVersionQuery({}, { refetchOnFocus: true, skip: timeSinceLastRefresh <= 2 });
	let showPopup = false;

	if (lastRefreshDate !== '' && device?.platform === 'web') {
		const releaseVersion = data?.response;

		const refreshRequired = !!(releaseVersion && !isError && releaseVersion !== RELEASE_VERSION);
		showPopup = refreshRequired && timeSinceLastRefresh > 2;
	}

	const handleClose = async (data: any) => {
		if (device?.platform === 'web') {
			await setLastRefreshDate(getNow());
			if (data !== 'cancel') {
				window.location.reload();
			}
		}
	};

	return (
		<>
			<>
				<IonAlert
					isOpen={showPopup}
					header="New Version available"
					message="Press OK to refresh"
					buttons={['OK', 'Cancel']}
					onDidDismiss={(e: CustomEvent) => handleClose(e.detail.role)}
				/>
			</>
		</>
	);
}

export function ReleaseVersionRefresh(): JSX.Element {
	const [, setLastRefreshDate] = usePreferences('lastRefreshDate');

	const handleRefresh = async () => {
		await setLastRefreshDate(addDays(getNow(), -2));
		window.location.reload();
	};
	const device = useDevice();
	return (
		<>
			<div onClick={handleRefresh} className={styles.releaseVersion}>
				v{RELEASE_VERSION}
				{device?.platform}
			</div>
		</>
	);
}
